import React from 'react';
import { TextField } from '@material-ui/core';

export default function DateTimeFilter(props) {
  return (
    <TextField
      {...props}
      type="datetime-local"
      variant="outlined"
      size="small"
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
}